var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDragIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 32,
  fill: "none",
  viewBox: "0 0 24 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M10 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2M14 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2M15 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0M10 15a1 1 0 1 0 0-2 1 1 0 0 0 0 2M15 18a1 1 0 1 1-2 0 1 1 0 0 1 2 0M10 19a1 1 0 1 0 0-2 1 1 0 0 0 0 2M15 22a1 1 0 1 1-2 0 1 1 0 0 1 2 0M10 23a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
})));
export { SvgDragIcon as ReactComponent };